/* eslint-disable */
(function (algolia) {
  'use strict';

  // Responsible for configuring and managing facets (filters). 
  // It defines how different types of facets (e.g., sliders, menus, refinement lists) 
  // are rendered and how they behave. 

  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var menu = algolia.externals.widgets.menu;
  var refinementList = algolia.externals.widgets.refinementList;

  algolia.MAX_INDIVIDUAL_FILTERS = Number(3);

  // Defines widgets for easy access.
  var TYPES_TO_WIDGET = {
    slider: {
      name: 'rangeSlider',
      useDefault: true,
      widget: rangeSlider,
    },
    menu: { name: 'menu', params: { limit: 100 }, widget: menu },
    conjunctive: {
      name: 'refinementList',
      params: { operator: 'and', limit: 18, showMore: true, showMoreLimit:100 },
      widget: refinementList,
    },
    disjunctive: {
      name: 'refinementList',
      params: { operator: 'or', limit: 18, showMore: true, showMoreLimit:100 },
      widget: refinementList,
    },
  };

  // Most classes are for the widgets ex RefinementList
  algolia.facetClasses = {
    root: 'facet',
    header: 'facet--header',
    body: 'facet--body',
    item: 'facet--item',
    label: 'facet--label',
    checkbox: 'facet--checkbox',
    active: 'facet--active',
    count: Boolean(algolia.config.show_products)
      ? 'facet--count-distinct'
      : 'facet--count',
  };

  //creates a list of facets( enabled and disabled) from config file
  // InstantSearch facets for filters:
  // algolia.config.facets = shop.metafields.algolia_search.instantsearch_facets
  var enabledFacets2 = algolia.config.facets.filter(facet => {
    return facet.enabled || parseInt(facet.enabled, 10);
  });

  // Modify enabledFacets to add one field, escapedName
  algolia.enabledFacetsWithEscapedName = enabledFacets2.map(
    facet => ({
      ...facet,
      escapedName: encodeURIComponent(facet.name),
    })
  );

  // Return facets that are NOT hidden
  algolia.notHiddenFacets =
    algolia.enabledFacetsWithEscapedName.filter(facet => {
      return facet.type !== 'hidden';
    });

  var facetToWidget = function (facet) {
    // Get the widget config based on the facet object type
    var widget = TYPES_TO_WIDGET[facet.type];
    // Grab the widget params
    var params = algolia.assign({}, widget.params);

    const containerClass =
      "[class~='facet-" + facet.escapedName + "-container']";

    // Add more attributes/fields to your params object
    params.container = containerClass;
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetClasses;

    /**
     * Providing a custom "Show more" template to confirm to the custom
     */
    params.templates.showMoreText = function showMoreText(
      data,
      { html }
    ) {
      return algolia.instantSearchShowMore(data, html);
    };

    // Our widgets are not searchable so this should not execute.
    if (facet.searchable) {
      params.searchable = true;
      params.searchablePlaceholder = 'Search for ' + facet.title;
      params.templates.searchableNoResults =
        '<div> No matching for ' + facet.title + '</div>';
    }

    // Add title to template header
    params.templates.header = function () {
      return facet.title;
    };

    // If this is not a slider widget execute
    if (!widget.useDefault) {
      params.templates.item = (item, { html }) => {
        return algolia.instantSearchFacetItem(item, html, facet.name);
      };
    }

    // facetSortFunctions only contains price-range function
    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    if (facet.type === 'slider') {
      //add any slider parameters here
      params.precision = -1; //rounds slider values to nearest tenth
      params.tooltips = {
        format(value) {
          return `${algolia.formatPrice(value)}`;
        },
      };
    }

    let displayFunction = algolia.facetDisplayFunctions[facet.name];

    // This contains an array of facet items
    // ex [{count: 133, isRefined: false, value: 'Decorative Accessories'}...]
    params.transformItems = function (items) {
      return items.map(item => ({
        ...item,
        type: facet.type,
        label: displayFunction
          ? displayFunction(item.value)
          : item.value,
      }));
    };

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  // try to fetch facets for current collection or fallback to collections default

  /** src/snippets/algolia_config.liquid sets the collection information based on
   * on the current collection id.
   * If current collection id and collection facets and the specific collection id facets
   * all exist then set collection_facets to specific collection id facets else to a default
   */
  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[
          algolia.current_collection_id
        ]
      : algolia.config.collection_facets &&
        algolia.config.collection_facets.default;

  if (collection_facets) {
    // Return enabled facets from collection_facets
    var enabledCollectionFacets2 = collection_facets.filter(
      (facet, index) => {
        return facet.enabled || parseInt(facet.enabled, 10);
      }
    );

    // Encode facet name and add it
    algolia.collectionFacetsWithEscapedName =
      enabledCollectionFacets2.map(facet => ({
        ...facet,
        escapedName: encodeURIComponent(facet.name),
      }));

    // Return collectionFacets that are not hidden. Price is excluded here because
    // algolia_instant_search_custom_rangeslider_widget.liquid already mounts a dedicated
    // slider+input pair into this same container when price is one of the shown facets -
    // leaving it in this list would additionally mount a second, bare, generic slider widget
    // into the same spot via the searchResultFilters loop in algolia_instant_search.js.liquid.
    algolia.collectionFacetsNotHiddenType =
      algolia.collectionFacetsWithEscapedName.filter(facet => {
        return facet.type !== 'hidden' && facet.name !== 'price';
      });

    algolia.searchResultFilters =
      algolia.collectionFacetsNotHiddenType.map(facetToWidget);
  }

  // If no collection facets found then use global facets config for search pages
  // searchResultFilters is use to display the three filters on top of search results
  if (!algolia.searchResultFilters || !algolia.searchResultFilters.length) {
    // Use global facets config for search pages
    var globalFacets = algolia.config.facets.filter(facet => {
      return facet.enabled || parseInt(facet.enabled, 10);
    });

    algolia.enabledFacetsWithEscapedName = globalFacets.map(
      facet => ({
        ...facet,
        escapedName: encodeURIComponent(facet.name),
      })
    );

    // Price excluded here for the same reason as the collection-specific filter above.
    algolia.notHiddenFacets =
      algolia.enabledFacetsWithEscapedName.filter(facet => {
        return facet.type !== 'hidden' && facet.name !== 'price';
      });

    // used for the 3 filters on top of search results
    algolia.searchResultFilters =
      algolia.notHiddenFacets.map(facetToWidget);
  }
  
})(window.algoliaShopify);
